var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('p',[_vm._v("사전교육 패키지")]),_c('br'),_vm._v("\n    Server Info(API URL - "+_vm._s(this.API_SERVER_URL)+") | ENV : "+_vm._s(this.NODE_ENV)+" | REL : "+_vm._s(this.NODE_REL)+" | Ver : "+_vm._s(this.PROJECT_VER)+"\n  ")]),_vm._v(" "),(this.NODE_REL === 'pre-release')?_c('div'):(this.NODE_REL === 'release')?_c('div'):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-897789d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodmosInfo.vue
// module id = null
// module chunks = 